import React, { Component } from 'react';
import {browserHistory} from 'react-router';
import PropTypes from 'prop-types';
import classname from 'classnames';
import { get as getCookie, remove as removeCookie } from 'js-cookie';
import { Grid, Row, Col } from 'react-bootstrap';
import { LoginWidgetScreen } from '@bizzabo/attendee-auth-api';

import config from 'config';
import AgendaSearch from './AgendaSearch';
import SessionList from './SessionList';
import LoaderView from '../LoaderView';
import TabButtons from './TabButtons';
import AgendaContextProvider from './AgendaContextProvider';
import { PreviewWindow } from '../PreviewWindow';
import SessionPageContainer from './SessionPageContainer';
import FeatureToggleUtils from 'FeatureToggleUtils';
import RegisterAndLoginModal from './RegisterAndLoginModal';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';

import {
    REGISTER_AND_LOGIN_MODAL_AGENDA_PAGE,
    MODAL_OPEN_DELAY,
    AGENDA_CONTAINER_ADDITIONAL_SIZE,
    VIRTUAL_VENUE_BANNER_SIZE
} from '../../../constants/Enums';
import LiveNowBanner from './LiveNowBanner';
import { getAccessToken, removeAccessToken, removeRefreshToken } from '../../../AuthToken';
import ThirdPartyCookieModal from '../ThirdPartyCookieModal';
import EmailLoginContainer_Deprecated from '../EmailLoginContainer_Deprecated';
import VirtualVenueBanner from '../VirtualVenueBanner';
import AttendeeLogin from '../AttendeeLogin';
import SsoEmailErrorModal from '../SsoEmailErrorModal';
import { loadVirtualSessionPage } from './sessionBroadcastUtils';

const AGENDA_SEARCH_CONTAINER_HEIGHT = 255;

class AgendaView extends Component {
    static propTypes = {
        event: PropTypes.object.isRequired,
        me: PropTypes.object.isRequired,
        eventUrls: PropTypes.object.isRequired,
        settings: PropTypes.object,
        siteConf: PropTypes.object,
        speakers: PropTypes.object.isRequired,
        selectedDays: PropTypes.array.isRequired,
        agendaDays: PropTypes.array.isRequired,
        selectDay: PropTypes.func.isRequired,
        hasSessions: PropTypes.bool.isRequired,
        filter: PropTypes.object.isRequired,
        selectedTags: PropTypes.array.isRequired,
        toggleFilter: PropTypes.func.isRequired,
        selectFilterCategory: PropTypes.func.isRequired,
        clearTime: PropTypes.func.isRequired,
        updateTime: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        selectTime: PropTypes.func.isRequired,
        clientNavigationAction: PropTypes.func.isRequired,
        clearLocationsTags: PropTypes.func.isRequired,
        clearCategoryTags: PropTypes.func.isRequired,
        toggleTag: PropTypes.func.isRequired,
        clearAllTags: PropTypes.func.isRequired,
        toggleMarker: PropTypes.func.isRequired,
        shouldFetchAgenda: PropTypes.bool.isRequired,
        fetchAgenda: PropTypes.func.isRequired,
        fetchSpeakers: PropTypes.func.isRequired,
        fetchMarkers: PropTypes.func.isRequired,
        fetchSessionRegData: PropTypes.func.isRequired,
        searchBySpeaker: PropTypes.func.isRequired,
        searchAgendaSessions: PropTypes.func.isRequired,
        agendaUrl: PropTypes.string.isRequired,
        isSessionRegistrationEnabled: PropTypes.bool,
        showEmailLogin: PropTypes.func.isRequired,
        hideEmailLogin: PropTypes.func,
        isEmailLoginShown: PropTypes.bool.isRequired,
        changeActiveTab: PropTypes.func.isRequired,
        getSessionsByIds: PropTypes.func.isRequired,
        activeTab: PropTypes.string.isRequired,
        shouldShowSessionPreviewWindow: PropTypes.bool.isRequired,
        shouldStickAgendaSearch: PropTypes.bool.isRequired,
        shouldShowSessionDescriptionAgenda: PropTypes.bool,
        changeViewMode: PropTypes.func.isRequired,
        viewMode: PropTypes.string.isRequired,
        fetchSponsorsByEvent: PropTypes.func,
        sessionsMap: PropTypes.object.isRequired,
        toggleSessionRegistrationStatusPerSession: PropTypes.func,
        openCloseTicketSelectionPopUp: PropTypes.func,
        selectTicketByUserAction: PropTypes.func,
        setSessionFullRegistration: PropTypes.func,
        setVirtualSessionDetails: PropTypes.func,
        setScrollToSessionBroadcastAction: PropTypes.func,
        setRecordUrl: PropTypes.func,
        isRingAvailable: PropTypes.bool,
    };

    static defaultProps = {
        settings: null,
        isSessionRegistrationEnabled: null
    };

    static getDerivedStateFromProps(nextProps, state) {
        if (!nextProps.isLoading && state.loadingMoreSessions && state.isLoading) {
            return {loadingMoreSessions: false, isLoading: nextProps.isLoading };
        }
        if (nextProps.isLoading !== state.isLoading) {
            return {isLoading: nextProps.isLoading};
        }
        return null;
    }

    state = {
        loadingMoreSessions: false,
        isLoading: this.props.isLoading,
        showPreviewWindow: false,
        currentSessionInPreviewWindow: null,
        agendaSearchContainerSize: !this.props.shouldStickAgendaSearch ? 0 : AGENDA_SEARCH_CONTAINER_HEIGHT,
        virtualSessionExist: false,
        isLiveNowBannerOpen: true,
        isRegisterAndLoginModalVisible: false,
        showThirdPartyCookieModal: false,
        isLoginFlowFeatureChecked: false,
        analyticData: null,
        hasFirstRenderCompleted: false,
        hasFirstNonLoadingRenderCompleted: false,
    };

    componentDidMount() {
        const {
            event: { id: eventId },
            shouldFetchAgenda,
            fetchAgenda,
            shouldFetchSpeakers,
            fetchSpeakers,
            fetchMarkers,
            fetchSessionRegData,
            fetchSponsorsByEvent,
            openCloseTicketSelectionPopUp,
            selectTicketByUserAction,
            ticketsSelectionData: {
                tickets,
                selectedTicketsIds
            },
            siteConf: {
                cookiesAreBlocked
            },
        } = this.props;
        if (shouldFetchAgenda) {
            fetchAgenda({ eventId });
        }
        if (shouldFetchSpeakers) {
            fetchSpeakers({ eventId });
        }
        fetchMarkers();
        fetchSessionRegData({ eventId });
        try {
            if (!selectedTicketsIds.length) {
                const storedEventId = localStorage.getItem('bz-selected-event');
                const storedTicketId = localStorage.getItem('bz-selected-ticket');
                const isTicketStored = storedEventId === eventId.toString() && storedTicketId;
                if (isTicketStored) {
                    selectTicketByUserAction(parseInt(storedTicketId), selectedTicketsIds);
                }
            }
        } catch {
            //
        }
        window.addEventListener('scroll', this.handleScroll);
        fetchSponsorsByEvent({id: eventId});

        if (cookiesAreBlocked){
            this.toggleShowThirdPartyCookieModal(true);
        }

        const { getUserTicketsByEvent } = this.props;

        getUserTicketsByEvent(eventId);

        // Notify external developers that AgendaView has mounted
        // Add delay to ensure parent window is ready to receive messages
        setTimeout(() => {
            try {
                const message = {
                    type: 'agenda-view-mounted',
                    timestamp: Date.now(),
                    eventId
                };
                window?.parent?.postMessage(message, '*');
            } catch (error) {
                console.warn('Failed to send agenda-view-mounted message:', error);
            }
        }, 100);
    }

    isWebLoginUsed() {
        return !FeatureToggleUtils.isFeatureEnabled('oldLogin');
    }

    componentDidUpdate(prevProps, prevState) {
        const isShowingHiddenSessionsEnabled = FeatureToggleUtils.isFeatureEnabled('show-hidden-sessions-in-agenda-registered-tab');
        if (this.props.activeTab !== prevProps.activeTab) {
            this.props.getSessionsByIds(this.props.sessions.ids, {
                registration: isShowingHiddenSessionsEnabled ? false : this.props.activeTab === 'registrations'
            });
        }
        if (!this.state.isLoginFlowFeatureChecked && !prevState.isLoginFlowFeatureChecked ||
            prevProps.enableLoginRegistrationPopUp !== this.props.enableLoginRegistrationPopUp) {
            const {
                siteConf: { cookiesAreBlocked }
            } = this.props;

            if (!cookiesAreBlocked && this.checkIsNeedToShowRegisterAndLoginModal()) {
                this.openRegisterAndLoginModalWithDelay();
            }
            this.setState({ isLoginFlowFeatureChecked: true });
        }

        // We don't need to show automatic login modal when another login modal is open
        if (this.props.isEmailLoginShown !== prevProps.isEmailLoginShown) {
            if (this.props.isEmailLoginShown && this.modalTimer) {
                clearTimeout(this.modalTimer);
                this.modalTimer = null;
            } else if (!this.props.isEmailLoginShown && this.checkIsNeedToShowRegisterAndLoginModal()) {
                this.openRegisterAndLoginModalWithDelay();
            }
        }

        // Notify external developers after first render is complete
        if (!this.state.hasFirstRenderCompleted) {
            this.setState({ hasFirstRenderCompleted: true });
            window?.parent?.postMessage({
                type: 'agenda-view-first-render-complete',
                timestamp: Date.now(),
                eventId: this.props.event.id
            }, '*');
        }

        // Notify external developers when first non-loading render occurs
        if (!this.state.hasFirstNonLoadingRenderCompleted && prevProps.shouldFetchAgenda && !this.props.shouldFetchAgenda) {
            this.setState({ hasFirstNonLoadingRenderCompleted: true });
            window?.parent?.postMessage({
                type: 'agenda-view-first-content-ready',
                timestamp: Date.now(),
                eventId: this.props.event.id
            }, '*');
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);

        if (this.modalTimer) {
            clearTimeout(this.modalTimer);
            this.modalTimer = null;
        }
    }

    updateVirtualSessionExist = (virtualSessionExist) => {
        this.setState({ virtualSessionExist: virtualSessionExist });
    }

    toggleShowLiveNowBanner = (isOpen) => {
        this.setState({ isLiveNowBannerOpen: isOpen });
    }

    toggleShowThirdPartyCookieModal = (show) => {
        this.setState({ showThirdPartyCookieModal: show });
    }

    handleThirdPartyCookieModalClose = () => {
        this.toggleShowThirdPartyCookieModal(false);
        if (this.checkIsNeedToShowRegisterAndLoginModal()) {
            this.openRegisterAndLoginModalWithDelay();
        }
    }

    handleScroll = () => {
        const { isLoading, sessions: { sessions, total } } = this.props;
        if (isLoading) {
            return;
        }
        const doc = document.documentElement;
        const windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        const offsetFromBottom = 500;
        if (windowTop + window.innerHeight >= document.body.clientHeight - offsetFromBottom) {
            if (total > sessions.length) {
                this.getMoreSessions();
            }
        }
    };

    openRegisterAndLoginModalWithDelay = () => {
        this.modalTimer = setTimeout(() => {
            this.showRegisterAndLoginModal();
            try {
                window.sessionStorage.setItem(REGISTER_AND_LOGIN_MODAL_AGENDA_PAGE, true);
            } catch (e) {
                console.warn('Could not access session storage due to privacy settings');
            }
        }, MODAL_OPEN_DELAY);
    };

  checkIsNeedToShowRegisterAndLoginModal = () => {
      const { enableLoginRegistrationPopUp, me: { id: userId }, siteConf: { isWidget }, isEmailLoginShown} = this.props;
      if (isWidget) {
          return false;
      }

      let wasModalShown = false;
      try {
          wasModalShown = window.sessionStorage.getItem(REGISTER_AND_LOGIN_MODAL_AGENDA_PAGE);
      } catch (e) {
          console.warn('Could not access session storage due to privacy settings');
      }
      const isAgendaLoginFlowEnabled = !FeatureToggleUtils.isFeatureEnabled('oldLogin');
      const isAuthenticated = !!(userId || getAccessToken());

      return (
          isAgendaLoginFlowEnabled &&
          enableLoginRegistrationPopUp &&
          !isAuthenticated &&
          !isWidget &&
          !isEmailLoginShown &&
          !wasModalShown
      );
  }

  getMoreSessions = () => {
      const { fetchPartOfSession } = this.props;
      this.setState({ loadingMoreSessions: true });
      fetchPartOfSession();
  };

  renderEmailLoginNew() {
      const {
          props: {
              eventUrls: { agendaUrl },
          },
      } = this;

      return (
          <AttendeeLogin
              closable
              screen={LoginWidgetScreen.login}
              redirectUrl={agendaUrl}
              hideRegisterAndLoginModal={this.hideRegisterAndLoginModal}
          />
      );
  }

  renderEmailLoginOld() {
      const {
          props: {
              eventUrls: { agendaUrl },
              event: { id, groupId },
          },
      } = this;

      return <EmailLoginContainer_Deprecated
          redirectUrl={agendaUrl}
          eventId={id}
          eventGroupId={groupId}
          headingText="Let's Get Started"
          subHeadingText="Enter the email used for event registration"
      />;
  }

  getChildContext() {
      return {agendaUrl: this.props.agendaUrl};
  }

  renderLoadMoreButton = () => {
      const { loadingMoreSessions } = this.state;
      const { sessions: { sessions, total } } = this.props;
      return loadingMoreSessions ? <Col className="text-center margin-vertical-small">
          <i className="fa fa-spinner fa-spin fa-2x" />
      </Col> :
          (total > sessions.length &&
        <div className="text-center">
            <button
                className="load-more-button button-user-profile color-1 no-style-link-button"
                onClick={this.getMoreSessions}>
            Load More
            </button>
        </div>
          );
  }

  showPreviewWindow = (sessionId) => {
      const {showPreviewWindow} = this.state;
      if (showPreviewWindow){
          this.setState({currentSessionInPreviewWindow: null}, () => this.setState({currentSessionInPreviewWindow: sessionId}));
      } else {
          this.setState({showPreviewWindow: true, currentSessionInPreviewWindow: sessionId});
      }
  };
  closePreviewWindow = () => this.setState({showPreviewWindow: false, currentSessionInPreviewWindow: null});

  showRegisterAndLoginModal = (analyticData = null) => this.setState({
      isRegisterAndLoginModalVisible: true,
      analyticData
  });

  hideRegisterAndLoginModal = () => this.setState({
      isRegisterAndLoginModalVisible: false
  });

  sessionClickHandler = (e, { sessionId = '', toExpend = false }) => {
      e.preventDefault();
      const { currentSessionInPreviewWindow } = this.state;
      const { shouldShowSessionPreviewWindow, event } = this.props;

      const sessionIdToShow = sessionId || currentSessionInPreviewWindow;
      const showingActiveSessionPopOut = sessionId === currentSessionInPreviewWindow;
      if (shouldShowSessionPreviewWindow && showingActiveSessionPopOut) {
          this.closePreviewWindow();
      } else if (shouldShowSessionPreviewWindow && !toExpend) {
          this.showPreviewWindow(sessionIdToShow);
      } else {
          loadVirtualSessionPage(sessionIdToShow, event);
      }
  };

  setSearchContainerHeight = (tabsHeight) => {
      const { shouldStickAgendaSearch } = this.props;

      if (shouldStickAgendaSearch) {
          this.setState({agendaSearchContainerSize: tabsHeight + AGENDA_SEARCH_CONTAINER_HEIGHT});
      } else {
          this.setState({agendaSearchContainerSize: 0});
      }
  };

  handleLogout = async() => {
      await removeRefreshToken();
      removeAccessToken();
      removeCookie('x-bz-vote-id');
      removeCookie(config.previewCookieName, {
          domain: window.location.hostname
      });

      window.location.reload();
  }

  render() {
      const { shouldFetchAgenda } = this.props;

      if (shouldFetchAgenda) {
          return (
              <LoaderView />
          );
      }
      const {
          showPreviewWindow,
          currentSessionInPreviewWindow,
          agendaSearchContainerSize,
          virtualSessionExist,
          isLiveNowBannerOpen,
          isRegisterAndLoginModalVisible,
          showThirdPartyCookieModal,
          analyticData,
      } = this.state;

      const {
          event,
          me,
          eventUrls,
          searchAgendaSessions,
          searchBySpeaker,
          siteConf,
          settings,
          selectDay,
          selectedDays,
          agendaDays,
          hasSessions,
          filter,
          selectedTags,
          toggleTag,
          clearTime,
          clearAllTags,
          speakers,
          clientNavigationAction,
          toggleMarker,
          isSessionRegistrationEnabled,
          showEmailLogin,
          isEmailLoginShown,
          sessions: {
              sessions,
              total,
              ids
          },
          activeTab,
          changeActiveTab,
          getSessionsByIds,
          agendaUrl,
          shouldShowSessionPreviewWindow,
          shouldStickAgendaSearch,
          isLoading,
          shouldShowSessionDescriptionAgenda,
          changeViewMode,
          viewMode,
          sessionsMap,
          sessionsToRender,
          getSliderSessions,
          toggleSessionRegistrationStatusPerSession,
          openCloseTicketSelectionPopUp,
          ticketsSelectionData,
          setSessionFullRegistration,
          setVirtualSessionDetails,
          setScrollToSessionBroadcastAction,
          setRecordUrl,
          setLoginV2OffsetTop,
          setLoginV2SpinnerOrigin,
          loginV2LoadingState,
          isRingAvailable,
      } = this.props;

      const { ringSettings, isWidget } = siteConf;

      if (!this.isWebLoginUsed() && isEmailLoginShown) {
          return this.renderEmailLoginOld();
      }

      const sessionPreviewWithBanner = () => {
          if (currentSessionInPreviewWindow) {
              const session = sessions.find(session => session.id === currentSessionInPreviewWindow);
              return session && !!session.imageUrl;
          }
      };

      const filterProps = {
          ...filter,
          handlers: {
              toggleTag,
              clearCategoryTags: this.props.clearCategoryTags,
              clearLocationsTags: this.props.clearLocationsTags,
              toggleFilter: this.props.toggleFilter,
              selectFilterCategory: this.props.selectFilterCategory,
              clearTime,
              updateTime: this.props.updateTime,
              selectTime: this.props.selectTime
          }
      };
      const selectedTagsProps = {
          tags: selectedTags.map(tag => ({
              ...tag,
              clearTag: (...args) => args.length === 0 ? clearTime() : toggleTag(...args)
          })),
          clearAllTags
      };
      const eventPublished = event.status === 'published';
      const previewContainerTop = !eventPublished ? 40 : 0;
      const color1 = siteConf && siteConf.color1;
      const previewContent = () => <SessionPageContainer
          previewSessionId={currentSessionInPreviewWindow}
          showControlPanel={false}
          topMargin={'none'}
          showBackgroundColor={false}
          displayInContainer={false}
          showCompactLists
          shouldUseCompactDescription
          stickSectionsToLeft
          sessionViewType={'sessionPreviewWindow'}
          toggleSessionRegistrationStatusPerSession={toggleSessionRegistrationStatusPerSession}
          openCloseTicketSelectionPopUp={openCloseTicketSelectionPopUp}
          ticketsSelectionData={ticketsSelectionData}
          setSessionFullRegistration={setSessionFullRegistration}
      />;

      const { displayLiveNowBanner = true } = settings;
      const isLoggedInUser = !!me.id;
      const isFeatureSessionVirtualElementEnabled = FeatureToggleUtils.isFeatureEnabled('feature-virtual-enable-virtual-suite');

      const agendaSearchClassName = classname('agenda-view session-list-view top-agenda-margin-single agenda-custom-css', {
          'agenda-day-selector': agendaSearchContainerSize > 0,
          'top-agenda-padding-banner': displayLiveNowBanner && !isLiveNowBannerOpen,
          'agenda-view--search': !isWidget,
      });
      const agendaContainerClass = `agenda-view session-list-view agenda-custom-css ${viewMode}`;

      const virtualVenueBannerClass = classname({
          [`virtual-venue-banner--fixed virtual-venue-banner--agenda virtual-venue-banner--${siteConf.template}`]: !isWidget,
      });

      let agendaContainerMarginTop = displayLiveNowBanner && isLiveNowBannerOpen && agendaSearchContainerSize !== 0 && virtualSessionExist
          ? agendaSearchContainerSize + AGENDA_CONTAINER_ADDITIONAL_SIZE
          : agendaSearchContainerSize;

      const shouldAddBannerMargin = ringSettings.isRingWorks && agendaSearchContainerSize !== 0 && !isWidget;
      const agendaVenueAlignmentEnabled = FeatureToggleUtils.isFeatureEnabled('seshreg-agenda-venue-behavior-alignment');
      const shouldRenderActions = agendaVenueAlignmentEnabled || !isRingAvailable;
      if (shouldAddBannerMargin) {
          agendaContainerMarginTop += VIRTUAL_VENUE_BANNER_SIZE;
      }

      return (
          <AgendaContextProvider agendaUrl={agendaUrl}>
              <Row className={agendaSearchClassName}>
                  <PreviewWindow
                      show={showPreviewWindow}
                      closeWindow={this.closePreviewWindow}
                      expand={e => this.sessionClickHandler(e, {toExpend: true})}
                      expandButtonText={'view session'}
                      color={color1}
                      customClass={sessionPreviewWithBanner() ? 'withSessionBanner' : ''}
                      content={currentSessionInPreviewWindow ? previewContent() : null}
                      previewContainerTop={previewContainerTop}/>
                  {!siteConf.isWidget
                      && <VirtualVenueBanner customWrapperClass={virtualVenueBannerClass} />}
                  {!isRingAvailable && displayLiveNowBanner &&
                  <LiveNowBanner
                      showLiveNowBanner={isLiveNowBannerOpen}
                      clientNavigationAction={clientNavigationAction}
                      toggleShowLiveNowBanner={this.toggleShowLiveNowBanner}
                      virtualSessionExist={virtualSessionExist}
                      updateVirtualSessionExist={this.updateVirtualSessionExist}
                      showRegisterAndLoginModal={this.showRegisterAndLoginModal}
                      setLoginV2OffsetTop={setLoginV2OffsetTop}
                      {...{
                          event,
                          me,
                          eventUrls,
                          showEmailLogin,
                          isFeatureSessionVirtualElementEnabled,
                          setVirtualSessionDetails,
                          setRecordUrl,
                          ticketsSelectionData
                      }}
                  />}
                  <Grid>
                      <Col className="agenda-search-container" xs={12} lg={12}>
                          <AgendaSearch
                              settings={settings}
                              selectedDays={selectedDays}
                              agendaDays={agendaDays}
                              filterProps={filterProps}
                              selectedTags={selectedTagsProps}
                              toggleTag={toggleTag}
                              selectDay={selectDay}
                              siteConf={siteConf}
                              clientNavigationAction={clientNavigationAction}
                              event={event}
                              searchAgendaSessions={searchAgendaSessions}
                              searchBySpeaker={searchBySpeaker}
                              setSearchContainerHeight={this.setSearchContainerHeight}
                              changeViewMode={changeViewMode}
                              viewMode={viewMode}
                              isLoggedInUser={isLoggedInUser}
                              onLogin={showEmailLogin}
                              onLogout={this.handleLogout}
                              isEmailLoginShown={isEmailLoginShown}
                              isWebLoginV2Used={this.isWebLoginUsed()}
                              isLiveNowBannerOpen={displayLiveNowBanner && isLiveNowBannerOpen && virtualSessionExist}
                              setLoginV2SpinnerOrigin={setLoginV2SpinnerOrigin}
                              loginV2LoadingState={loginV2LoadingState}
                              setLoginV2OffsetTop={setLoginV2OffsetTop}
                          />
                      </Col>
                  </Grid>
                  {shouldRenderActions && <TabButtons
                      sessionsTotal={total}
                      sessionsToRender={sessionsToRender}
                      activeTab={activeTab}
                      me={me}
                      ids={ids}
                      eventUrls={eventUrls}
                      showEmailLogin={showEmailLogin}
                      changeActiveTab={changeActiveTab}
                      getSessionsByIds={getSessionsByIds}
                      isSessionRegistrationEnabled={isSessionRegistrationEnabled}
                      isLoading={isLoading}
                      settings={settings}
                      setLoginV2OffsetTop={setLoginV2OffsetTop}
                      siteConf={siteConf}
                  />}
              </Row>
              <Row className={agendaContainerClass} style={{marginTop: `${agendaContainerMarginTop}px`}}>
                  <Grid>
                      <Col xs={12} lg={12}>
                          <SessionList
                              {...{
                                  event,
                                  me,
                                  sessions,
                                  selectedDays,
                                  speakers,
                                  settings,
                                  agendaDays,
                                  hasSessions,
                                  clientNavigationAction,
                                  eventUrls,
                                  siteConf,
                                  toggleMarker,
                                  isSessionRegistrationEnabled,
                                  showEmailLogin,
                                  isLoading,
                                  sessionClickHandler: this.sessionClickHandler,
                                  shouldShowSessionPreviewWindow,
                                  shouldShowSessionDescriptionAgenda,
                                  viewMode,
                                  loadingMoreSessions: this.state.loadingMoreSessions,
                                  sessionsMap,
                                  sessionsToRender,
                                  ids,
                                  activeTab,
                                  clearAllTags,
                                  changeActiveTab,
                                  getSessionsByIds,
                                  getSliderSessions,
                                  toggleSessionRegistrationStatusPerSession,
                                  openCloseTicketSelectionPopUp,
                                  ticketsSelectionData,
                                  setSessionFullRegistration,
                                  shouldStickAgendaSearch,
                                  setVirtualSessionDetails,
                                  setScrollToSessionBroadcastAction,
                                  setRecordUrl,
                                  showRegisterAndLoginModal: this.showRegisterAndLoginModal,
                                  setLoginV2OffsetTop,
                                  isRingAvailable,
                              }}
                          />
                          { this.renderLoadMoreButton() }
                      </Col>
                  </Grid>
              </Row>
              <RegisterAndLoginModal
                  show={isRegisterAndLoginModalVisible}
                  onHide={this.hideRegisterAndLoginModal}
                  eventName={this.props?.event?.name}
                  eventStatus={this.props?.event?.status}
                  onLoginClick={showEmailLogin}
                  eventUrls={eventUrls}
                  isEmailLoginShown={isEmailLoginShown}
                  setLoginV2SpinnerOrigin={setLoginV2SpinnerOrigin}
                  loginV2LoadingState={loginV2LoadingState}
                  analyticData={analyticData}
              />
              <ThirdPartyCookieModal
                  show={showThirdPartyCookieModal}
                  onHide={this.handleThirdPartyCookieModalClose}
              />
              {
                  this.isWebLoginUsed() &&
                  isEmailLoginShown &&
                  !showPreviewWindow &&
                  this.renderEmailLoginNew()
              }
              <SsoEmailErrorModal />
          </AgendaContextProvider>
      );
  }
}

export default AgendaView;
